import _ from "lodash";
import styled, { css } from "styled-components";
import { resolveFileUrl } from "constants/config";

import ModalWrapper from "components/modals/modal-wrapper";

import useModal from "hooks/useModal";

import { EModals } from "types/enums";

const OverlayedGallery = () => {
    const { state, setStateByKey } = useModal(EModals.OverlayedGallery, {});

    return (
        <ModalWrapper
            name={EModals.OverlayedGallery}
            extra={`background: transparent; padding: 0; width: 100%; max-width: 900px; gap: 15px; @media (max-width: 991px) { width: 100vw; padding: 0; };`}
        >
            <Gallery.MainPhoto src={resolveFileUrl(state?.photos?.[state?.currentPhotoNumber])} />
            <Gallery.Wrapper>
                {_.map(state?.photos, (photo, index) => (
                    <Gallery.Photo
                        key={index}
                        src={resolveFileUrl(photo)}
                        onClick={() => setStateByKey(`currentPhotoNumber`, index)}
                        isActive={index === state?.currentPhotoNumber}
                    />
                ))}
            </Gallery.Wrapper>
        </ModalWrapper>
    );
};

export const Gallery = {
    MainPhoto: styled.img`
        width: 100%;
        height: 600px;
        object-fit: contain;
        object-position: center;

        @media (max-width: 991px) {
            height: 250px;
        }
    `,
    Wrapper: styled.div`
        display: inline-flex;
        max-width: 900px;
        overflow: auto;
        gap: 15px;
    `,
    Photo: styled.img<{ isActive?: boolean }>`
        width: 100%;
        height: 100px;
        object-fit: cover;
        object-position: center;
        cursor: pointer;
        ${({ isActive }) =>
            isActive &&
            css`
                border: 2px solid #fff;
                box-sizing: border-box;
            `}
    `,
};

export default OverlayedGallery;
